module.exports = __webpack_public_path__ + "img/write-notes-from-laptop.4a74af23.jpg";